import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import { Select } from 'hb-react/shared/components/formik/components/inputs';
import type { User } from 'hb-react/types/user';

export const Kind = ({ currentUser }: { currentUser: User | null }) => {
  const { kindConfigurations = [], kinds = [] } = useJobContext();

  const locale = currentUser?.locale || I18n.locale;

  const options = kinds.map(({ id, name }) => {
    const config = kindConfigurations.find(
      ({ kind_id: kindId }) => kindId === id,
    );

    return config
      ? {
          id: config.kind_id,
          name: config.names[locale],
        }
      : {
          id,
          name,
        };
  });

  return (
    <Select
      label={s__('JobForm|Type of opportunity')}
      name="kind_id"
      options={options}
      validate={{ required: true }}
    />
  );
};
